import { ProductCardProps } from '@teko/types/ecommerce';
import { create } from 'zustand';

// Subset of the product card props needed to render the "Sản phẩm đang xem"
// block and to add the viewing product straight to cart.
export type IComboPopupProduct = Pick<
  ProductCardProps,
  | 'sku'
  | 'sellerSku'
  | 'name'
  | 'imageUrl'
  | 'uom'
  | 'price'
  | 'selectPromotionId'
  | 'brand'
> & {
  // Stepper quantity from the product-detail page for "Mua sản phẩm đang xem".
  // Not on ProductCardProps (cards have no stepper); other callers default 1.
  quantity?: number;
};

interface IComboPopupStore {
  // Flag gate, kept in sync by ComboPopupRenderer.
  enabled: boolean;
  // Selected product to show combos for (undefined = popup closed).
  selectedProduct?: IComboPopupProduct;
  setEnabled: (enabled: boolean) => void;
  open: (product: IComboPopupProduct) => void;
  close: () => void;
}

// Holds the combo-popup state outside React so the pure helper
// createHandleEventAndCtaButton can open the popup from ANY product-card
// surface (search, infinite scroll, page-builder blocks, video preview...)
// via useComboPopupStore.getState(), without threading a hook through configs.
export const useComboPopupStore = create<IComboPopupStore>((set) => ({
  enabled: false,
  selectedProduct: undefined,
  setEnabled: (enabled) => set({ enabled }),
  // Ignore opens while disabled so a stale getState() can never show the popup.
  open: (product) =>
    set((state) => (state.enabled ? { selectedProduct: product } : {})),
  close: () => set({ selectedProduct: undefined }),
}));
